var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFaceOff(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_1",
    "data-name": "Camada 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 44.81 44.64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "-face_off") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Camada_1-2",
    "data-name": "Camada_1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.47,44.18c9.37-4,9.21-8,9.21-17.7,0-4.58.59-14.77-.77-18.47A12.07,12.07,0,0,0,32.7.09c-6.31-.2-12.93,0-19.27,0-5.2,0-10,2.12-12.13,7C-.59,11.42.14,19.92.14,25.12c0,6.73-.48,11.7,3.38,15.81s8.82,3.61,15.59,3.67l0-17.11H13.51l-.12-6.64h5.76c0-4.54-.36-8.77,2.34-11.46C23.84,7,28.76,6.67,32.86,7.45V13.3c-5.77.57-7.21-1.92-6.83,7.56l6.53,0-.8,6.66H26V44.61c2.34-.07,7.7.28,9.46-.43Z",
    transform: "translate(0 0)",
    fill: "#cacaca",
    fillRule: "evenodd"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaceOff);
export default __webpack_public_path__ + "static/media/face_off.0b9a161db05924b099e88f3573ef4afe.svg";
export { ForwardRef as ReactComponent };